// Duplicated from leave Quote
export const leaveClaim = {
  data() {
    return {
      routeTo: undefined,
      // Skip prompt to use internally only
      skipPrompt: false,
      promptLeave: false
    }
  },
  methods: {
    doExit() {
      try {
        this.skipPrompt = true
        this.$router.push(this.routeTo.path)
      } catch (e) { }
    },
    async doSaveAndExit() {
      // Emit saving event on global event bus
      // Each Claim page should listen to this and do partial Submit and save
      this.$root.$emit('saveClaim', true)
    }
  },
  // If user tries to leave this quotation, it will prompt leave message
  beforeRouteLeave(to, from, next) {
    if (this.skipPrompt) {
      next()
    } else {
      if (this.$store.state.claims.claimDetail.promptWhenExit) {
        this.routeTo = to
        this.promptLeave = true
        next(false)
      } else {
        next()
      }
    }
  },
  created() {
    this.$root.$on('leaveClaim', () => {
      this.doExit()
    })
  },
  beforeDestroy() {
    this.$root.$off('leaveClaim')
  }
}
